// utils/buildBlocksReqTranslationCsv.js – 2025-06-11
//
//  ▸ default  export:  buildBlocksReqTranslationCsv(rows)
//      – takes the rows array from <SimplifiedDiffContent> and returns
//        a CSV of only the ⚑-flagged blocks (needsTranslation === true)
//
//  ▸ named    export:  buildBlocksReqTranslationCsvForSite(destEntry, primaryEntry)
//      – given two fully-populated manual entries (dest-locale + primary-locale),
//        returns a CSV of the blocks that still need translation on the dest site.
//
//  Both exporters use Papa.unparse (safe for embedded XML fragments).

import Papa from "papaparse";
import { parse as json2csv } from "json2csv"; // papa.unparse URI encodes strings which is hard to unwind so we use json2csv

const FALLBACK_TS = new Date("2025-04-29T00:00:00Z");

/* ──────────────────────────────────────────────────────────────────── */
/*  1) DEFAULT  – filter the already-flattened “rows” array            */
/* ──────────────────────────────────────────────────────────────────── */

export default function buildBlocksReqTranslationCsv(rows = []) {
  if (!Array.isArray(rows) || rows.length === 0) return "";

  const toTranslate = rows.filter(r => r.needsTranslation);
  if (toTranslate.length === 0) return "";

  const csvRows = toTranslate.map(r => ({
    entryType: r.entryType,
    entryId: r.entryId,
    entryUserTitle: r.entryUserTitle,
    entryContent: r.entryContent,
    entryTypeHandle: r.entryTypeHandle,
    entryParentId: r.entryParentId,
    calloutType: r.calloutType,
    sortOrder: r.sortOrder,
    sectionHandle: r.sectionHandle,
    parentNestedEntryTypeHandle: r.parentNestedEntryTypeHandle,
    stepBuilderParent: r.stepBuilderParent,
    stepBuilderSortOrder: r.stepBuilderSortOrder,
    youtubeVideo: r.youtubeVideo,
    /* audit columns */
    dateUpdatedPrimarySite: r.dateUpdatedPrimarySite,
    translationImportTimestampCurrentSite:
      r.translationImportTimestampCurrentSite,
    exportTimestamp: r.exportTimestamp || new Date().toISOString(),
  }));

  return json2csv(csvRows, { unwind: true, flatten: true });
}
